import { Badge } from "antd";
import { h } from "preact";

interface IShowBadege {
  changeDeviceCount: number
}

export const ShowBadge = ({changeDeviceCount}: IShowBadege) => {
  return (
    <Badge
      count={changeDeviceCount}
      style={{ position: "absolute", top: "-20px", right: "-15px" }}
    />
  );
};
